var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowCheckoutModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0306 1.53104L9.53055 9.03104C9.4609 9.10077 9.37818 9.15609 9.28713 9.19384C9.19608 9.23158 9.09849 9.25101 8.99993 9.25101C8.90137 9.25101 8.80377 9.23158 8.71272 9.19384C8.62168 9.15609 8.53896 9.10077 8.4693 9.03104L0.969304 1.53104C0.828573 1.39031 0.749512 1.19944 0.749512 1.00042C0.749512 0.801394 0.828573 0.610522 0.969304 0.469792C1.11003 0.329061 1.30091 0.25 1.49993 0.25C1.69895 0.25 1.88982 0.329061 2.03055 0.469792L8.99993 7.4401L15.9693 0.469792C16.039 0.400109 16.1217 0.344834 16.2128 0.307122C16.3038 0.26941 16.4014 0.25 16.4999 0.25C16.5985 0.25 16.6961 0.26941 16.7871 0.307122C16.8781 0.344834 16.9609 0.400109 17.0306 0.469792C17.1002 0.539474 17.1555 0.6222 17.1932 0.713245C17.2309 0.804289 17.2503 0.901871 17.2503 1.00042C17.2503 1.09896 17.2309 1.19654 17.1932 1.28759C17.1555 1.37863 17.1002 1.46136 17.0306 1.53104Z",
    fill: "#512D9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowCheckoutModal);
export default __webpack_public_path__ + "static/media/down-arrow-checkout-modal.0b581c09a4c6b9032acd0f8397747671.svg";
export { ForwardRef as ReactComponent };